/* Importaciones de React */
import React, { useState, useEffect, useCallback } from "react"

/* Importaciones de MUI */
import { Stack, Typography, TextField, InputAdornment, Button } from "@mui/material"
import { Person } from "@mui/icons-material"
import { BsFillFileTextFill } from "react-icons/bs";

/* Importaciones del modulo de Shared */
import { ModalView } from "../../../Shared";
import {trackingReports as getTrackingReports} from '../../../Shared/Fetch';


export default function AddFromPrevScanner({ displayState, addItems}){
    /* Estados */
    const [show, setShow] = displayState;
    // const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [trackReports, setTrackReports] = useState([]);

    const [uuidMovement, setUuidMovement] = useState('');
    const [description, setDescription] = useState('');

    const clearForm = useCallback(() => {
        setUuidMovement('')
    }, [])

    const params = new URLSearchParams({
        UUIDValue: uuidMovement,
        userId: 0,
        companieId: 0,
        operation: 0,
        carrierId: 0,
        start: 0,
        end: 0
      })

    const handleGetReports = () => {
        try {
            console.log('handleGetReports');
            setIsLoading(true);
            getTrackingReports(params, setTrackReports);
            setShow(false)
            setIsLoading(false)
            setUuidMovement('')
        }
        catch (error) {
            console.error("Error en la solicitud:", error);
        }
    }
    useEffect(() => {
        if (trackReports && trackReports.length > 0) {
            console.log('trackReports', trackReports);
            const transformedData = trackReports.map(item => ({
                numero: item.waybill,
                kg: item.peso_kg ? parseFloat(item.peso_kg) : 1,
                alto: item.alto ? parseFloat(item.alto) : 0,
                ancho: item.ancho ? parseFloat(item.ancho) : 0,
                largo: item.largo ? parseFloat(item.largo) : 0,
                origenCP: item.origin_zip_code || "",
                destinoCP: item.destination_zip_code || "",
                descripcion: description,
                created_at: new Date()
            }));
            addItems(transformedData);
        }
    }, [trackReports]);
    
    /* Componente */
    return(
        <ModalView
            displayState={displayState}
            width={'32%'}
            maxHeight={'85%'}
        >
            <Stack
                direction='column'
                spacing={2}
            >
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 700,
                        textAlign: 'center'
                    }}
                >
                    Escanie manifiesto para importar los items
                </Typography>

                <TextField 
                    label={'UUID del manifiesto'}
                    placeholder={'Escanie manifiesto'}
                    value={uuidMovement}
                    onChange={event => setUuidMovement(event.target.value)}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><Person color="primary" /></InputAdornment>
                    }}
                    fullWidth
                    focused
                    required
                />
                <TextField 
                    label={'Descripcion de movimiento'}
                    placeholder={'Descripcion de movimiento (opcional)'}
                    minRows={2}
                    value={description}
                    onChange={event => setDescription(event.target.value)}
                    InputProps={{
                        startAdornment: <BsFillFileTextFill
                                color = "#ff4500"
                                fontWeight = "700"
                                size = "1.25rem"
                            />
                    }}
                    fullWidth
                    focused
                />

            </Stack>

            <Stack
                direction='row'
                alignItems='center'
                justifyContent='right'
            >
                <Button 
                    onClick={handleGetReports}
                    sx={{ fontSize: '12.4px' }}
                    disabled={isLoading || uuidMovement == ''}
                >
                    Importar
                </Button>

                <Button
                    onClick={() => {
                        clearForm()
                        setShow(false)
                    }}
                    sx={{ fontSize: '12.4px' }}
                >
                    Cerrar
                </Button>
            </Stack>
        </ModalView>
    )
}